import { isCustomDropdownValue, decodeCustomDropdownValue } from './dropdownCustomValue';

/**
 * Display Total Floors:
 * 0 → "Ground Floor", 1 → "G+1", 2 → "G+2", …
 */
export function formatTotalFloors(value) {
  if (value === null || value === undefined) return null;
  if (typeof value === 'string' && value.trim() === '') return null;

  let raw = value;
  if (isCustomDropdownValue(value)) {
    raw = decodeCustomDropdownValue(value);
    if (raw === null || raw === undefined || String(raw).trim() === '') return null;
  }

  const str = String(raw).trim();
  if (/^-?\d+(\.\d+)?$/.test(str)) {
    const num = Number(str);
    if (!Number.isFinite(num)) return str;
    if (num === 0) return 'Ground Floor';
    return `G+${Math.trunc(num)}`;
  }

  return str;
}
